"use client";

import { PiCheckCircle, PiWarningCircle } from "react-icons/pi";

import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/toast/toast";
import { useToast } from "@/components/toast/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && (
                <ToastTitle>
                  {props.variant === "success" && <PiCheckCircle className="w-6 h-6" />}
                  {props.variant === "destructive" && <PiWarningCircle className="w-6 h-6" />}
                  {title}
                </ToastTitle>
              )}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
